import { ConditionType } from '../../component/form/search-key-input.component';
import { HeadCell } from '../../component/table/table.component';
import apiManage from '../../request';
import _ from 'lodash';
import LSM from '../../modules/cache/tool-local-storage';
import { LOCAL_STORAGE_KEYS } from '../../modules/cache/local-storage.constant';
import { makeAutoObservable, observable } from 'mobx';
import { WillStopConfig } from '../../request/http';
import GlobalNotification from '../../component/common/snackbar';
import i18n from '../../i18n';
import { Condition, ResellerConsumption } from '../../models';
import moment from 'moment';
import { dateValidate } from '../../constants/tool-order';
import { accountState } from '../my-account/account-state';

// 经销商数据管理
export class ResellerConsumptionState implements ResellerConsumptionData {

    constructor() {
        makeAutoObservable(this);
    }

    // *********************
    // Attributes
    // *********************

    // 语言
    language: string = LSM.get(LOCAL_STORAGE_KEYS.LANGUAGE) || 'EN';
    // 经销商数据列表
    resellerConsumptionList: ResellerConsumption[] = [];
    dataTotal: number = 0;
    // 搜索框内容
    searchValue: string = '';
    // 下拉框默认值 左边条件搜索下拉框
    selectValue: string = 'reseller_name';
    // 表格加载
    isTableLoading: boolean = false;
    // 新建经销商弹窗标识
    isOpenDialog: boolean = false;
    // 弹窗加载loading
    isLoading: boolean = false;
    // 排序参数 前端 ：0 不排序  1 降序 2 升序，后端：-1 降序 1 升序
    extraSortParams: {
        sort_key: string,
        sort_value: number
    } = { sort_key: '', sort_value: 0 };
    // 经销商额外传参
    extraParams: ResellerConsumption = {};

    // 搜索条件
    conditions = observable<ConditionType>([]);
    // 每页数量
    perPage = 9999;
    // 当前页码
    page = 0;
    // 显示经销商账号详情
    showUnit: boolean = false;
    // 点击经销商列表行详情按钮进去的数据
    enterResellerDetailObj: {
        key: number;
        resellerConsumptionData: ResellerConsumption
    } = {
            // 进入经销商详情索引
            key: -1,
            // 进入经销商详情数据
            resellerConsumptionData: {}
        };
    // 时间组件显示操
    viewDateTimeData: {
        // 开始时间
        startDate: Date | null,
        // 结束时间
        endDate: Date | null,
    } = {
            startDate: null,
            endDate: null
        };
    // api传参开始时间
    startDate: string = '';
    // api传参结束时间
    endDate: string = '';

    // 初始化
    async init() {
        // 初始化默认为倒序
        const params: any = { sort_value: '-1' };
        this.setSortParams(params);
        // 时间默认今天
        const { startTime, endTime } = validateCurrentDate();
        this.viewDateTimeData.startDate = moment(startTime, 'YYYY-MM-DD HH:mm').toDate();
        this.viewDateTimeData.endDate = moment(endTime, 'YYYY-MM-DD HH:mm').toDate();
        this.startDate = moment(startTime, 'YYYY-MM-DD HH:mm').toISOString()
        this.endDate = moment(endTime, 'YYYY-MM-DD HH:mm').toISOString()
        await this.getResellerConsumptionListData();
    }

    setIsOpenDetail(val: boolean) {
        this.showUnit = val
    }

    // 获取表头排序状态值
    getSortStatus(key: string) {
        const listSort = this.extraSortParams;
        if (key === listSort.sort_key) {
            return listSort.sort_value
        }
        return 0;
    }

    // 表格排序
    async handleSort(headCell: HeadCell) {
        // 前端 ：0 不排序  1 降序 2 升序，后端：-1 降序 1 升序
        const sortValue = headCell?.sortStatus === 0 ? 1 : headCell?.sortStatus === 1 ? 2 : 0;
        // 设置传参
        this.setSortParams({
            sort_key: headCell.id,
            sort_value: sortValue,
        });
        this.getResellerConsumptionListData();
    }

    /**
     * 设置排序参数
     * @param val 排序参数
     */
    setSortParams(val: typeof this.extraSortParams) {
        this.extraSortParams = val;
    }

    // 表格加载
    loadTable() {
        return this.isTableLoading = true;
    }

    // 加载完毕
    loadedTable() {
        return this.isTableLoading = false;
    }

    // 开启加载  弹窗loading
    load() {
        this.isLoading = true
    }

    // 关闭加载  弹窗loading
    loaded() {
        this.isLoading = false;
    }

    /**
     * 设置下拉框的值 左边搜索条件下拉框
     * @param value
     */
    async setSelectValue(value: string) {
        this.selectValue = value;

    }

    /**
     * 设置获取经销商消费数据额外传参
     * @param extraParam
     */
    setExtraParams(extraParam: ResellerConsumption & Condition) {
        this.extraParams = extraParam;
    }

    // 设置搜索条件
    async setConditions(val: ConditionType[]) {
        this.conditions.replace(val);
        const extraParams = {};
        val.forEach((item) => {
            extraParams[item.key] = extraParams[item.key] ? _.concat(extraParams[item.key], item.value) : [item.value];
        })

        this.setExtraParams(extraParams);
        await this.getResellerConsumptionListData(extraParams);

    }

    /**
     * 时间选择
     * @param date
     */
    handleChangePicker(dates: [Date | null, Date | null] | undefined) {
        // 开始时间
        this.viewDateTimeData.startDate = dates?.[0] ?? null;
        // 结束时间
        this.viewDateTimeData.endDate = dates?.[1] ?? null;
        if (dates) {
            if (dates[0] && dates[1] && dateValidate(dates[0], dates[1])) {
                this.startDate = moment(dates[0]).toISOString();
                this.endDate = moment(dates[1]).toISOString();
                this.getResellerConsumptionListData()
            }
        }
    }

    // 更新经销商数组
    updateData(data: ResellerConsumption[], totalCount: number) {
        this.resellerConsumptionList = data || [];
        this.dataTotal = totalCount;
    }

    /**
     * 获取余额明细数据
     * @param extraParam 经销商数据获取额外传参 有排序和搜索值
     */
    async getResellerConsumptionListData(extraParam?: ResellerConsumption) {
        // 开启加载
        this.loadTable();

        // 排序参数转换
        const sortObj = this.extraSortParams.sort_key && this.extraSortParams.sort_value !== 0 ? {
            sort_key: this.extraSortParams.sort_key,
            // 前端 ：0 不排序  1 降序 2 升序，后端：-1 降序 1 升序
            sort_value: this.extraSortParams.sort_value === 2 ? 1 : -1,
        } : {
            // 默认排序:创建时间倒序
            sort_value: -1
        };
        // 发送的参数
        const params = {
            pagination_per_page: this.perPage,
            pagination_page: this.page + 1,
            key: LSM.get(LOCAL_STORAGE_KEYS.LANGUAGE) === 'CN' ? 'CN' : 'EN',
            ...this.extraParams,
            ...extraParam,
            ...sortObj,
            start_date: this.startDate,
            end_date: this.endDate,
        }
        // 经销商登录时, 只获取经销商的数据
        if (accountState.userInfo?.account_type === 'RESELLER') {
            _.set(params, 'belonged_reseller', accountState.userInfo?._id)
        }
        // 请求集团接口
        const result = await apiManage.get_reseller_consumption_condition({ ...params }, {
            // api太慢。请求下一个时需要取消上个请求
            stop_by_unmount: true
        } as WillStopConfig);
        if (result.message === 'canceled') {
            // 请求被取消
            return
        }
        // 获取成功
        if (!result.error) {
            // 解构数据
            const { dbResults, totalCount } = result[0];
            this.updateData(dbResults || [], _.get(totalCount, '0.count', 0))
        } else {
            // 获取失败
            GlobalNotification.error(i18n.t('general_text_fetch_data_error'));
        }
        // 关闭加载
        this.loadedTable();
    }
}


// 经销商消费页数据
type ResellerConsumptionData = {
    // 经销商消费
    resellerConsumptionList: Array<ResellerConsumption>;
    // 搜索框内容
    searchValue: string;
    // 下拉框默认值
    selectValue: string;
    // 表格加载
    isTableLoading: boolean;
    // 弹窗加载loading
    isLoading: boolean;
}


// 校验当天日期逻辑
export const validateCurrentDate = () => {
    let startTime: string;
    let endTime: string;
    // 现在的时间
    const presentDate = new Date();
    /**
     * 根据现在的时刻  即商家进入系统初始化的时刻  判断获取数据是从哪一天开始获取
     * 1. 商家在04:00 - 23:59 时，看的是当天 04:00 - 次日 04:00 的数据
     * 2. 商家在00:00 - 03:59 时，看的是昨日 04:00 - 当日 04:00 的数据
     */
    if (moment(presentDate).isBefore(moment('04:00', 'HH:mm'))) {
        // 开始时间是00:00 - 03:59，取昨日 04:00 - 当日 04:00 的数据
        startTime = moment(presentDate).subtract(1, 'day').format('YYYY-MM-DD 04:00');
        endTime = moment(presentDate).format('YYYY-MM-DD 04:00');
    } else {
        // 开始时间是04:00 - 23:59，取当天 04:00 - 次日 04:00 的数据
        startTime = moment(presentDate).format('YYYY-MM-DD 04:00');
        endTime = moment(presentDate).add(1, 'day').format('YYYY-MM-DD 04:00');
    }
    return {
        startTime,
        endTime
    }
}